import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled, { css } from "styled-components";
import { NotificationBubbleDot } from "@faire/retailer/components/Header/icons/NotificationBubbleDot";
var TRANSITION_SPEED_MS = "300ms";
export var IconWithMaybeDot = function(param) {
    var icon = param.icon, hasHighPriority = param.hasHighPriority, shouldAnimateDot = param.shouldAnimateDot, dataTestId = param.dataTestId, shouldShowDot = param.shouldShowDot, dotBottom = param.dotBottom, dotLeft = param.dotLeft, isActive = param.isActive, delayAnimationTime = param.delayAnimationTime;
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsxs(Row, {
        style: {
            width: "40px"
        },
        children: [
            !isSSR && shouldShowDot ? /*#__PURE__*/ _jsx(NotificationBubble, {
                $hasHighPriority: hasHighPriority,
                "data-test-id": "".concat(dataTestId).concat(hasHighPriority ? "-priority" : ""),
                $dotBottom: dotBottom,
                $dotLeft: dotLeft,
                children: /*#__PURE__*/ _jsx(NotificationBubbleDot, {
                    hasHighPriority: hasHighPriority,
                    shouldAnimate: shouldAnimateDot,
                    delayAnimationTime: delayAnimationTime
                })
            }) : null,
            /*#__PURE__*/ _jsx(IconWrapper, {
                $isActive: isActive,
                align: "center",
                justify: "center",
                children: icon
            })
        ]
    });
};
var IconWrapper = styled(Row).withConfig({
    componentId: "sc-2c92773-0"
})([
    "&:hover{background-color:",
    ";}height:40px;width:40px;",
    " border-radius:50%;transition:all ",
    " ease-out;"
], Core.surface.subdued, function(param) {
    var $isActive = param.$isActive;
    return $isActive ? css([
        "background-color:",
        ";"
    ], Core.surface.subdued) : null;
}, TRANSITION_SPEED_MS);
var NotificationBubble = styled(Row).withConfig({
    componentId: "sc-2c92773-1"
})([
    "position:absolute;left:",
    ";bottom:",
    ";",
    "{left:",
    ";}z-index:1;&:hover + ",
    "{transition:all ",
    " ease-in;background-color:",
    ";padding:",
    ";}"
], function(props) {
    return props.$dotLeft ? css([
        "",
        "px"
    ], props.$dotLeft) : "22px";
}, function(props) {
    return props.$dotBottom ? css([
        "",
        "px"
    ], props.$dotBottom) : "22px";
}, responsiveMediaQueries.desktopAndAbove, function(props) {
    return props.$dotLeft ? css([
        "",
        "px"
    ], props.$dotLeft) : "18px";
}, IconWrapper, TRANSITION_SPEED_MS, Core.surface.subdued, getSpacing("1x"));
